import React from 'react';
import classes from './YaAuth.module.scss';
import { athena_state } from 'helpers/oauth2';
import { useAppSelector } from 'store/hook';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import auth from 'api/auth';
import { saveTokensAfterAuthentication } from 'helpers/cookies';
import api from 'api';
import EnterPassword from 'routes/PasswordInputes/EnterPassword';
import { functionCollectBrowserData } from 'helpers/browserData/functionCollectBrowserData';

const client_id = window.REACT_APP_YA_CLIENT_ID !== 'REPLACE_REACT_APP_YA_CLIENT_ID' ? window.REACT_APP_YA_CLIENT_ID : process.env.REACT_APP_YA_CLIENT_ID;
const yandex_client_secret = window.REACT_APP_YA_CLIENT_SECRET !== 'REPLACE_REACT_APP_YA_CLIENT_SECRET' ? window.REACT_APP_YA_CLIENT_SECRET : process.env.REACT_APP_YA_CLIENT_SECRET;
const authType = window.REACT_APP_AUTH_TYPE !== 'REPLACE_REACT_APP_AUTH_TYPE' ? window.REACT_APP_AUTH_TYPE : process.env.REACT_APP_AUTH_TYPE; 
const loginAdress = authType === 'blitz' ? 'blitz-auth' : 'login';

const YaAuth = () => {
  const [needToEnterPass, setNeedToEnterPass] = React.useState(false);
  const [authData, setAuthData] = React.useState<any>({});
  const [isLoading, setIsLoading] = React.useState(false);
  
  const { messageApi } = useAppSelector((state) => state.windowState);
  
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getYaTokens = async (params: any) => {
    const code_verifier = String(localStorage.getItem('code_verifier'));
    const device_id = localStorage.getItem('device_id');
    const device_name = `browser_${athena_state}`;
    const client_secret = yandex_client_secret;

    if (params.state === athena_state) {
      const browserData = await functionCollectBrowserData();

      try {
        const response = await auth.externalAuthLogin({
          pkce_auth_data: {...params, code_verifier, client_id, device_id, device_name, client_secret},
          service_name: 'yandex',
          browser_data: JSON.stringify(browserData),
        });        
        if (response.data?.has_oauth_integration) {
          saveTokensAfterAuthentication(response.data);
          navigate('/');
        } else {
          setAuthData(response.data)
          setNeedToEnterPass(true);
        }
      } catch (error: any) {
        console.error(error);
        if (error?.response?.data?.message?.includes("Can't find user with email")) {
          const regex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
          const emails = error?.response?.data?.message?.match(regex);
          messageApi?.error(t('login.external.errorAuthViaExternal', {email: emails[0], name: t('login.external.btns.yandex')}), 12);
        } else {
          messageApi?.error(t('login.external.errorRequestDataAuth', {name: t('login.external.btns.yandex')}));
        }
        navigate(`/${loginAdress}`);
      } finally {
        localStorage.removeItem('code_verifier');
      }
    }
  };

  React.useEffect(() => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const paramsObject = Object.fromEntries(urlParams.entries());
      if (paramsObject?.code) {
        getYaTokens({ code: paramsObject?.code, state: paramsObject?.state });
      }
    };
  }, [window.location.search]);

  const checkPassword = async (values: { password: string }) => {
    try {
      setIsLoading(true);
      await auth.checkPassword(values.password, `Bearer ${authData.access_token}`);
      saveTokensAfterAuthentication(authData);
      navigate('/');

      await api.addExternalAuth({
        service_name: 'yandex',
        external_id: authData.external_id,
      });      
      messageApi?.success(t('checkPassword.successSend', {name: t('login.external.btns.yandex')}), 10);
    } catch (err: any) {      
      messageApi?.error(t('checkPassword.failedSend'), 6);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={classes.mainWrap}>
      {needToEnterPass 
        ? <EnterPassword name={'yandex'} authData={authData} checkPassword={checkPassword} isLoading={isLoading}/>
        : <div id='root'><div className={classes.lds}><div className={classes.ldsRipple}><div></div><div></div></div></div></div>
      }
    </div>
  );
}

export default YaAuth;

